import { useMutation } from '@tanstack/react-query';
import { Event } from '../../../types/Event';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const postEvent = async (formData: Event) => {
  const response = await CustomAxios.post(`events`, formData);
  const { data } = response;
  return data;
};

type useCreateEventProps = {
  onSuccessCallback: (data: any) => void;
};
export function useCreateEvent({ onSuccessCallback }: useCreateEventProps) {
  return useMutation({
    mutationKey: [mutationKeys.createEvent],
    mutationFn: (formData: Event) => postEvent(formData),
    onSuccess: (data: any) => {
      // fetch the events again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, 'new'] });

      // call success
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const event: Event = err.response.data as Event;
        queryClient.setQueryData([queryKeys.allEvents, 'new'], event);
      }
    },
  });
}
